import { Box } from '@mui/material';

import { DocumentsApi } from 'api';
import { ReactComponent as ClipIcon } from 'assets/images/ic-clip-gray.svg';
import { ContainerItem, Text } from 'ui';
import { getMimeType, openFileInNewWindow } from 'util/files.util';
import { cropInput } from 'util/format.util';

export const Attachments: React.FC<{
  attachments: { file_name: string; id: string; orgId: string; bucket: string }[];
  attachmentsPadding?: string;
  noLabel?: boolean;
  label?: string;
  labelColor?: 'gray' | 'black';
  cropInputLength?: number;
}> = (props) => {
  const { attachments, attachmentsPadding, noLabel, label, labelColor, cropInputLength } = props;

  const documentsApi: DocumentsApi = new DocumentsApi();

  const openDocument = (id: string, orgId: string, bucket: string) => {
    documentsApi.getDocument(orgId, id).then((document) => {
      documentsApi.getDocumentLink(bucket, document.s3_key, 'get').then((s3Url) =>
        fetch(s3Url.s3LinkPath).then(async (response) => {
          const blob = await response.blob();
          openFileInNewWindow(blob, getMimeType(document.file_name), document.file_name);
        })
      );
    });
  };

  return (
    <>
      {!noLabel && (
        <ContainerItem padding={attachmentsPadding ? attachmentsPadding : '4px 0'}>
          <Text
            sx={{
              width: '100%',
              fontWeight: '700',
              fontSize: '13px',
              lineHeight: '15px',
              color: (theme) =>
                labelColor === 'gray' ? theme.palette.text.secondary : theme.palette.text.primary
            }}
            content={label ? label : 'Attachments'}
          />
        </ContainerItem>
      )}
      <ContainerItem flex padding={noLabel ? '12px 0' : '8px 0 0 0'} align="center" flexWrap="wrap">
        {attachments?.map((file, index) => {
          return (
            <Box
              sx={{
                width: 'auto',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginRight: '2px'
              }}
              onClick={() => openDocument(file.id, file.orgId, file.bucket)}
            >
              <ClipIcon width="18px" height="18px" />
              <Text
                sx={{
                  fontWeight: '400',
                  fontSize: '13px',
                  lineHeight: '140%',
                  cursor: 'pointer',
                  color: (theme) => theme.palette.secondary.main
                }}
                content={cropInput(file.file_name, cropInputLength ?? 30, 'document')}
              />
              {attachments && index !== attachments?.length - 1 && (
                <Text
                  sx={{
                    fontWeight: '400',
                    fontSize: '13px',
                    lineHeight: '140%',
                    cursor: 'pointer',
                    color: (theme) => theme.palette.text.primary
                  }}
                  content=","
                />
              )}
            </Box>
          );
        })}
      </ContainerItem>
    </>
  );
};
